import React from 'react';
import { Link } from 'react-router-dom';

export type BreadCrumbProp = {
  text: string;
  to: string;
}

type Props = {
  items: BreadCrumbProp[]
  style?: React.CSSProperties;
};

export function BreadCrumb(props: Props) {
  return (
    <ul className="breadcrumb" id="breadcrumb" style={{...props.style, marginBottom: 0 }}>
      { props.items.map((item, index) => (
          <li key={ index } className="breadcrumb-item">
            <Link to={item.to}>{item.text}</Link>
          </li>
      )) }
    </ul>
  )
}